export const initialData = {
  nome: '',
  uf: '',
  cod_ibge: '',
}
export default initialData;
